// HubexTech Talent app API as constant
const HUBEXTECH_TALENT_APP_API = {
    // Resume Listing as constant
    RESUME_LIST: '/api/employees?',
    // Populate all data
    DATA_SET: '&populate=%2A'
}
export default HUBEXTECH_TALENT_APP_API